import { render, staticRenderFns } from "./loader-dialog.vue?vue&type=template&id=0b2125e2&"
import script from "./loader-dialog.vue?vue&type=script&lang=js&"
export * from "./loader-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports